import React from "react";
import * as S from "./styles";

const Welcome = () => {
  return (
    <S.PageContainer className="entry-app-content">
      <div className="content-holder">
        <div>
          <S.Container>
            <h2>Seja bem-vindo ao Colabi</h2>
            <p>Selecione uma das opções no menu ao lado</p>
          </S.Container>
        </div>
      </div>
    </S.PageContainer>
  );
};

export default Welcome;
